import React, { useCallback, useState } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Checkbox from '@wconcept/wconcept-ui-renewal/components/atoms/Checkbox';
import ModalTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ModalTitle';
import ModalGroupBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalGroupBtn';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import AccordionPanel from '@wconcept/wconcept-ui-renewal/components/molecules/Accordion/AccordionPanel';
import AccrdnNoticeType from '@wconcept/wconcept-ui-renewal/components/organisms/_accordion/AccrdnNoticeType';
import * as S from './style';

export interface MarketingAgreeResult {
  appPush: boolean;
  sms: boolean;
  email: boolean;
}

interface IProps {
  onSubmit?: (result: MarketingAgreeResult) => void;
  onClose?: () => void;
  value: { isDesktop: boolean; isApp: boolean; isIPhoneXApp: boolean };
}

const MarketingAgreeModal = ({ onSubmit, onClose, value }: IProps) => {
  const { isDesktop, isApp, isIPhoneXApp } = value;
  const [isAgree, setIsAgree] = useState(false);

  const handleAgreeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsAgree(e.target.checked);
    },
    []
  );

  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function')
      onSubmit({
        appPush: isApp && !isDesktop && isAgree,
        sms: isAgree,
        email: isAgree,
      });
  }, [onSubmit, isApp, isDesktop, isAgree]);

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.MarketingAgreeModal className={isIPhoneXApp ? 'is-old-app-iphonex' : ''}>
      {isDesktop ? (
        <ModalCloseBtn onClick={handleClose} />
      ) : (
        <ModalEdgeCloseBtn onClick={handleClose} />
      )}
      <ModalTitle title="광고성 정보 수신 동의 후 쿠폰 받기" />
      <div className="content">
        <Checkbox
          type="type1"
          id="MarketingAgree"
          label="마케팅 활용을 위한 개인 정보 수집 및 이용 동의"
          value="MarketingAgree"
          checked={isAgree}
          onChange={handleAgreeChange}
        />
        <Text
          className="desc"
          weight={500}
          size={15}
          lineHeight="130%"
          align="center"
          block
        >
          마케팅 정보는 아래 채널로 발송되며, <br />
          수신 동의 시 쿠폰이 즉시 발급 됩니다.
        </Text>
        <div className="agree-box">
          <ul className={isAgree ? 'channel-list active' : 'channel-list'}>
            {isApp && !isDesktop && <li className="app-push">App Push</li>}
            <li className="sms">SMS</li>
            <li className="e-mail">E-Mail</li>
          </ul>
        </div>

        <AccrdnNoticeType>
          <AccordionPanel
            label={
              <div className="agree-title">
                광고성 정보 수신/마케팅 활용 동의 안내
              </div>
            }
            value="notice-1"
          >
            <div className="agree-ctns">
              <table>
                <colgroup>
                  <col width="20.5%" />
                  <col width="39.75%" />
                  <col width="39.75%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>수집항목</th>
                    <th>이용목적</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="center">마케팅 활용</td>
                    <td>이메일 주소, 휴대폰 번호, 생년월일, 성별</td>
                    <td className="highlight">
                      신규 서비스/상품 안내 등 마케팅 활용 및 광고성 정보 전달
                    </td>
                  </tr>
                </tbody>
              </table>
              <ul>
                <li className="highlight">
                  개인정보의 보유 및 이용 기간 :{' '}
                  <span>회원탈퇴 시 또는 법적 의무 보유기간</span>
                </li>
                <li>
                  선택사항의 동의를 거부하시는 경우에도 회원가입 및 구매결제 등
                  필수서비스는 이용할 수 있습니다.
                  <br />
                  단, 일부 부가서비스는 제한될 수 있습니다.
                </li>
              </ul>
            </div>
          </AccordionPanel>
        </AccrdnNoticeType>
      </div>
      <ModalGroupBtn
        type={isDesktop ? 'balance' : 'rightBig'}
        secondaryBtn={{ text: '취소', onClick: handleClose }}
        borderTop
        primaryBtn={{
          text: '동의하고 쿠폰 받기',
          onClick: handleSubmit,
          disabled: !isAgree,
        }}
      />
    </S.MarketingAgreeModal>
  );
};

export default MarketingAgreeModal;
